module.exports = __webpack_public_path__ + "images/FUSA_icons/055-online-shop-1.658f7f88c181eed6a207bdd82597f0bd.svg";